import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from '../players'; // Importing PlayersView component
import FilterCasinoReport from '../agent/reports/casinoReport/filterCasinoReport'; // Importing filter component for casino report
import TableCasinoReport from '../agent/reports/casinoReport/tableCasinoReport'; // Importing table component for casino report
import DetailsCasinoReport from '../agent/reports/casinoReport/detailsCasinoReport'; // Importing details component for casino report
import RecordCasinoReport from '../agent/reports/casinoReport/recordCasinoReport'; // Importing record component for casino report
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Casino Report View.
 * @extends JetView
 */
export default class CasinoReportView extends JetView {
    /**
     * Configures the layout of the Casino Report View.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right section containing record and details components
        const right = {
            type: 'wide',
            rows: [RecordCasinoReport, DetailsCasinoReport],
        };

        // Toolbar configuration with pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetch from configuration
                },
            ],
        };

        // Left section containing filters and table
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label', // Label for the report title
                            label: _('Reporte de Casino'), // Localized report title
                            width: 500,
                        },
                    ],
                },
                FilterCasinoReport, // Filter component for the casino report
                TableCasinoReport, // Table component for displaying casino report data
                toolbar, // Including the toolbar with pagination
            ],
        };

        // Returning the overall layout configuration
        return {
            type: 'wide',
            cols: [left, right], // Left and right sections in a column layout
        };
    }
}

// FILE DOCUMENTED
